import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import TileGroup from '../tiles/TileGroup';
import Month from './Month';
import { getYear, getFullDate } from '../../utils/dates';
var Months = function Months(props) {
  var start = 0;
  var end = 11;
  var activeStartDate = props.activeStartDate;
  return /*#__PURE__*/React.createElement(TileGroup, _extends({}, props, {
    activeStartDate: activeStartDate,
    containerClassName: "ap-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      return getFullDate(getYear(activeStartDate), monthIndex, 1);
    },
    dateType: "month",
    end: end,
    start: start,
    tile: Month
  }));
};
export default Months;